import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { BacteriaBackground } from "../../assets";
import "./BacteriaSlider.css";
import "./Style/Style.css";

const BacteriaSlider = ({
  value,
  onChange,
  sliderMarks = {
    1: "EC20",
    2: "SpaC",
    3: "H.G.T",
  },
  size = 3,
}) => {
  return (
    <div className="h-[6.5rem] w-screen flex justify-center md:justify-normal relative top-0 z-1000">
      <div className="md:w-1/2 w-3/5 md:right-0 absolute mt-12 md:mr-[10vw]">
        <Slider
          min={1}
          max={size}
          step={1}
          value={value}
          onChange={onChange}
          handleStyle={{
            backgroundImage: `url(${BacteriaBackground})`,
            backgroundSize: "cover",
            marginLeft: "3px",
            opacity: 1,
            borderColor: "var(--violet-pale)",
            zIndex: "0",
          }}
          trackStyle={{
            backgroundColor: "var(--violet-pale)",
          }}
          marks={sliderMarks}
          dotStyle={{
            borderColor: "var(--violet-pale)",
          }}
        />

        <div className="text-slider-container">
          <p className="text-slider">Click on each step to view its details</p>
        </div>
      </div>
    </div>
  );
};

export default BacteriaSlider;
